module.exports = "https://bin.bnbstatic.com/_next/static/images/Coin-Rendering-72c799fb54b150d058522150740b4801.png";